import { useCallback, useEffect, useState } from 'react';

const KEY = 'reload-theme';

/**
 * Thème clair par défaut, y compris sur une machine réglée en sombre : le fond
 * blanc est le parti pris de l'interface, le sombre un choix explicite qui se
 * retient d'une visite à l'autre.
 */
export function readStoredMode() {
  try {
    return localStorage.getItem(KEY) === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
}

export function applyTheme(mode) {
  document.documentElement.dataset.theme = mode === 'dark' ? 'dark' : 'light';
}

export default function useTheme() {
  const [mode, setMode] = useState(readStoredMode);

  useEffect(() => {
    applyTheme(mode);
    try {
      if (mode === 'dark') localStorage.setItem(KEY, 'dark');
      else localStorage.removeItem(KEY);
    } catch { /* stockage indisponible : le choix ne survivra pas à la session */ }
  }, [mode]);

  const toggle = useCallback(() => {
    setMode((m) => (m === 'dark' ? 'light' : 'dark'));
  }, []);

  return { mode, resolved: mode, setMode, toggle };
}
